const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getDepositMethodsApi = async (page = 1, perPage = 15, query = '') => {
    const token = localStorage.getItem('token');
    
        if (!token) {
      console.error('[getDepositMethodsApi] Ошибка: Токен авторизации не найден.');

        // throw new Error('Токен авторизации не найден.');
    }



    let url = `${API_BASE_URL}/admin/lead/deposit-methods?page=${page}&per_page=${perPage}`;
    
    if (query) {
        url += `&query=${encodeURIComponent(query)}`;
    }

    try {
        const response = await fetch(
            url, 
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData?.message || `Ошибка ${response.status}: не удалось получить методы депозита`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};